import React, { useRef } from 'react';
import { IonItemSliding, IonItem, IonLabel, IonItemOptions, IonItemOption, AlertButton, IonText, IonIcon, IonButton } from '@ionic/react';
import { star, starOutline, personOutline } from 'ionicons/icons';
import './SessionListItem.css';
import { Session } from '../models/Schedule';
import TrackPill from './TrackPill';
import { useHistory } from 'react-router-dom';
import FavoritesService from '../services/FavoritesService';


interface SessionListItemProps {
  session: Session;
  day: string;
  listType: "all" | "favorites";
  onAddFavorite: (id: string) => void;
  onRemoveFavorite: (id: string) => void;
  onShowAlert: (header: string, buttons: AlertButton[]) => void;
  isFavorite: boolean;
}
const SessionListItem: React.FC<SessionListItemProps> = ({ isFavorite, onAddFavorite, onRemoveFavorite, onShowAlert, day, session, listType }) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);
  const history = useHistory();
  //console.log(day);
  const dismissAlert = () => {
    ionItemSlidingRef.current && ionItemSlidingRef.current.close();
  }
  //console.log(typeof session.id, session.id);
  const idsession = session.id.toString();

  const removeFavoriteSession = async() => {
    onShowAlert('Ya existe en favoritos', [
      {
        text: 'Cancelar',
        handler: dismissAlert
      },
      {
        text: 'Eliminar',
        handler: async() => {
          try {
            await FavoritesService.getInstance().removeFavorite(idsession);
            onRemoveFavorite(idsession);
            onShowAlert('Sesión eliminada de favoritos', [
              { text: 'OK', handler: dismissAlert }
            ]);
          } catch (error) {
            console.error('SessionListItem: No se pudo eliminar el favorito:', error);
            onShowAlert('No se pudo actualizar favoritos', [
              { text: 'OK', handler: dismissAlert }
            ]);
          }
          dismissAlert();
        }
      }
    ]);
  }

  const addFavoriteSession = async() => {
    if (isFavorite) {
      // woops, they already favorited it! What shall we do!?
      // prompt them to remove it
      removeFavoriteSession();
    } else {
      try {
        await FavoritesService.getInstance().addFavorite(idsession);
        onAddFavorite(idsession);
        onShowAlert('Sesión agregada a favoritos', [
          { text: 'OK', handler: dismissAlert }
        ]);
      } catch (error) {
        console.error('SessionListItem: No se pudo agregar el favorito:', error);
        onShowAlert('No se pudo actualizar favoritos', [
          { text: 'OK', handler: dismissAlert }
        ]);
      }
    }
  };

  // Obtener el nombre y el color del track principal
  const mainTrack = session.tracks[0];
  const parts = mainTrack.split('&&&');
  const mainTrackName = parts[0];
  const mainTrackColor = parts.length > 1 && parts[1] ? parts[1] : 'var(--ion-color-primary)';
  const mainTrackClass = `track-${mainTrackName.toLowerCase().replace(/ /g, '-')}`;

  // Determinar si estamos en modo oscuro
  const isDarkMode = document.body.classList.contains('dark-theme');

  return (
    <IonItem className={`${mainTrackClass} rounded my-2 shadow-sm hover-up transition-fast track-item`} lines="none" style={{
      overflow: 'hidden',
      borderLeft: `6px solid ${mainTrackColor}`,
      position: 'relative',
      backgroundColor: isDarkMode ? '#1e1e1e' : undefined,
      color: isDarkMode ? 'white' : undefined,
      boxShadow: isDarkMode ? '0 4px 12px rgba(0, 0, 0, 0.3)' : undefined
    }}>
      <div className="session-content" style={{ width: '100%' }} onClick={() => history.push(`/tabs/schedule/${session.id}`)}>
        <IonLabel style={{ whiteSpace: 'normal', color: isDarkMode ? 'white' : undefined }} className="ion-padding-vertical-sm session-label">
          <h3 className="session-title" style={{
            fontWeight: '600',
            marginBottom: '8px',
            paddingRight: '40px',
            color: isDarkMode ? 'white' : undefined
          }}>{session.name}</h3>
          <p className="session-details" style={{
            fontWeight: '500',
            fontSize: '13px',
            marginBottom: '4px',
            color: isDarkMode ? '#cccccc' : undefined
          }}>
            {session.timeStart} &mdash;&nbsp;
            {session.timeEnd} &nbsp;|&nbsp;
            {session.location}
          </p>

          {/* Mostrar ponentes solo si existen y no son el valor por defecto */}
          {session.speakerNames &&
           session.speakerNames.length > 0 &&
           !session.speakerNames.includes('Sin conferencista asignado') &&
           session.speakerNames[0] !== '' && (
            <p className="session-speakers" style={{
              fontWeight: '400',
              fontSize: '12px',
              marginBottom: '6px',
              color: isDarkMode ? '#a0a0a0' : '#666666',
              fontStyle: 'italic'
            }}>
              <IonIcon
                icon={personOutline}
                style={{
                  fontSize: '12px',
                  marginRight: '4px',
                  verticalAlign: 'middle'
                }}
              />
              {session.speakerNames.join(', ').toUpperCase()}
            </p>
          )}

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '2px' }}>
            {session.tracks.map(track => (
              <TrackPill key={track} track={track} />
            ))}
          </div>
        </IonLabel>
      </div>
      <div
        className="favorite-icon-wrapper"
        onClick={(e) => {
          e.stopPropagation();
          isFavorite ? removeFavoriteSession() : addFavoriteSession();
        }}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          cursor: 'pointer',
          padding: '5px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10
        }}
      >
        <IonIcon
          icon={isFavorite ? star : starOutline}
          color={isFavorite ? "warning" : "medium"}
          style={{ fontSize: '18px' }}
        />
      </div>
    </IonItem>
  );
};

export default React.memo(SessionListItem);
